<template>
  <div class="footer">
    <div class="footer-wrap">
      <div class="logo-image">
        <img src="@/assets/images/icon-13.png" alt="" class="icon-image" />
        <div class="contact-info">
          <div class="company-name">福建通文产业服务有限公司</div>
          <div class="contact-item">客服热线：0592-2191066</div>
          <div class="contact-item">工作时间：08:00-18:00</div>
          <div class="contact-item">手机：13695005173</div>
          <div class="contact-item">邮箱：157235262@qq.com</div>
          <div class="contact-item">地址：厦门市集美区珩圣路386号226室</div>
        </div>
      </div>
      <div class="tab-wrap" v-if="navList.length && !isMobile">
        <div v-for="(item, index) in navList" :key="index" class="tab-detail">
          <!-- <div class="parent-title" v-if="item.list"> {{item.categoryName}}</div> -->
          <div
            class="parent-title parent-point"
            @click="handleEnter(item, item.categoryCode, 1)"
          >
            {{ item.categoryName }}
          </div>
          <div
            v-for="(t, i) in item.list"
            :key="i"
            class="child-title"
            @click="handleEnter(t, item.categoryCode, 2)"
          >
            {{ t.categoryName }}
          </div>
        </div>
      </div>

      <!-- 手机端也展示二维码区块，避免商务联系方式丢失 -->
      <div class="qrcode-wrap">
        <div class="qrcode-item">
          <img src="@/assets/images/icon-38.jpg" alt="" class="qrcode-img" />
          <div class="qrcode-text">关注通文</div>
        </div>
        <div class="qrcode-item">
          <img src="@/assets/images/icon-39.png" alt="" class="qrcode-img" />
          <div class="qrcode-text">商务合作</div>
        </div>
        <div class="qrcode-item">
          <img src="@/assets/images/icon-40.jpg" alt="" class="qrcode-img" />
          <div class="qrcode-text">实训基地</div>
        </div>
      </div>

    </div>
    <div class="copyright-wrap">
      <div class="wrap-title">
        <span class="copyright-text">Copyright© 版权所有 福建通文产业服务有限公司</span>
        <!-- 将备案图标与备案号作为一个整体，避免移动端被换行拆开 -->
        <span class="record-wrap">
          <img src="@/assets/images/icon-37.png" alt="" class="image" />
          <a target="_blank" href="https://beian.miit.gov.cn/" class="a"
            >闽ICP备2025105166号</a
          >
        </span>
        <!-- 许可证相关信息分组，便于移动端控制单行展示 -->
        <span class="license-wrap">
          <img src="@/assets/images/icon-36.png" alt="" class="license-icon" />
          <a
            target="_blank"
            href="https://www.fjtwfw.com/articleDetail?categoryId=209&linkType=1&tabcode=103&seccode=209&id=2043942658392489985"
            class="license-link"
            >电子营业执照</a
          >
          <a
            target="_blank"
            href="https://www.fjtwfw.com/articleDetail?categoryId=112&linkType=3&tabcode=103&seccode=112&id=2043942202681360386"
            class="license-link"
            >人力资源服务许可证</a
          >
        </span>
      </div>
      <!-- <div class="content">
        <span>Copyright© 版权所有</span>
        <span>福建通文产业服务有限公司</span>
        <span>All Rights Reserved.</span>
        <span>
          备案号：<a target="_blank" href="https://beian.miit.gov.cn/"
            >闽ICP备2025105166号</a
          >
        </span>
      </div> -->
    </div>
  </div>
</template>

<script>
import { getNavList } from '@/api/common/common'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      navList: []
    }
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile // 假设 isMobile 在根 state 下
    })
  },
  methods: {
    fetchData() {
      getNavList({ websiteType: 1 }).then((res) => {
        this.navList = []
        res.data.forEach((item, index) => {
          if (index > 0 && item.categoryName !== '赛事活动') {
            this.navList.push(item)
          }
        })
      })
    },
    handleEnter(item, tabcode, typeIndex) {
      if (item.list && typeIndex == 1) {
        item = item.list[0]
      }
      this.currentCode = tabcode
      console.log(item.linkUrl)

      if (item.linkUrl == 'home') {
        this.$router.push('/')
      } else {
        let baseUrl =
          '?categoryId=' +
          item.categoryCode +
          '&linkType=' +
          item.linkType +
          '&tabcode=' +
          tabcode +
          '&seccode=' +
          item.categoryCode
        let url = ''
        // 实训基地   基地介绍   实训资源
        if (['123', '130'].indexOf(item.categoryCode) != -1) {
          url = '/base/introduction' + baseUrl
          url =
            item.linkUrl || item.url != null ? url + '&id=' + item.linkUrl : url
          this.$router.push(url)
          return
        }

        // 实训项目
        if (['202'].indexOf(item.categoryCode) != -1) {
          url = '/base/project' + baseUrl
          url =
            item.linkUrl || item.url != null ? url + '&id=' + item.linkUrl : url
          this.$router.push(url)
          return
        }
        //师资队伍
        if (['132'].indexOf(item.categoryCode) != -1) {
          url = '/base/faculty' + baseUrl
          url =
            item.linkUrl || item.url != null ? url + '&id=' + item.linkUrl : url
          this.$router.push(url)
          return
        }
        //线上课程
        if (['134'].indexOf(item.categoryCode) != -1) {
          url = '/base/course' + baseUrl
          url =
            item.linkUrl || item.url != null ? url + '&id=' + item.linkUrl : url
          this.$router.push(url)
          return
        }
        // 协同育人模块
        if (['139', '140', '141'].indexOf(item.categoryCode) != -1) {
          url = '/collaboration' + baseUrl
          url =
            item.linkUrl || item.url != null ? url + '&id=' + item.linkUrl : url
          this.$router.push(url)
          return
        }
        if (item.linkType == '7') {
          window.open(item.linkUrl)
        } else {
          switch (item.linkType) {
            case '1':
              url = '/article' + baseUrl
              break
            case '2':
              url = '/singleImage' + baseUrl
              break
            case '3':
              url = '/imageText' + baseUrl
              break
            case '5':
              url = '/tabList' + baseUrl
              break
            case '8':
              url = '/coopPartner' + baseUrl
              break
            case '9':
              url = '/contactUs' + baseUrl
              break

            default:
              baseUrl
          }
          url =
            item.linkUrl || item.url != null ? url + '&id=' + item.linkUrl : url
          this.$router.push(url)
        }
      }
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
.footer {
  color: #fff;
  background: #1b56a9;
  display: table;

  .footer-wrap {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    padding: 36px 0 64px;
    width: 1340px;
    margin: 0 auto;

    .logo-image {
      display: flex;
      flex-direction: column;
      width: 300px;
      .icon-image {
        width: 135px;
        height: 26px;
        object-fit: contain;
      }
      .contact-info {
        margin-top: 20px;
        .company-name {
          font-size: 16px;
          font-weight: bold;
          color: rgba(255, 255, 255, 0.9);
          margin-top: 6px;
          letter-spacing: 1px;
        }
        .contact-item{
          font-size: 16px;
          font-weight: bold;
          color: rgba(255, 255, 255, 0.9);
          line-height: 30px;
          margin-top: 15px;
        }
      }
    }
    .tab-wrap {
      display: flex;
      justify-content: center;
      flex: 1;
      .tab-detail {
        width: 100px;

        text-align: center;
        .parent-title {
          font-size: 16px;
          color: #fff;
          font-weight: bold;
        }
        .parent-point {
          cursor: pointer;
        }
        .child-title {
          font-size: 16px;
          line-height: 16px;
          cursor: pointer;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 30px;
        }
        .child-title:hover {
          color: #fff;
        }
      }
    }
    .qrcode-wrap {
      display: flex;
      justify-content: flex-start;
      gap: 40px;
      width: 400px;
      .qrcode-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .qrcode-img {
          width: 110px;
          height: 110px;
          border-radius: 8px;
          background: #fff;
          padding: 2px;
        }
        .qrcode-text {
          font-size: 15px;
          color: #fff;
          margin-top: 10px;
          text-align: center;
        }
      }
    }
  }
  .copyright-wrap {
    border-top: 1px solid #fff;
    background: #1d2129;
    display: flex;
    flex-direction: column;
    padding: 24px 0;
    .wrap-title {
      font-size: 18px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      margin-left: 450px;
      .copyright-text {
        margin-right: 15px;
      }
      .record-separator {
        margin-right: 15px;
        color: rgba(255, 255, 255, 0.5);
      }
      .image {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
      .a {
        color: #fff;
        margin-left: 3px;
      }
      .record-wrap {
        display: inline-flex;
        align-items: center;
        white-space: nowrap;
      }
      .license-wrap {
        display: inline-flex;
        align-items: center;
        white-space: nowrap;
      }
      .license-icon {
        width: 18px;
        height: 18px;
        margin-left: 15px;
        margin-right: 5px;
      }
      .license-link {
        color: #fff;
        text-decoration: none;
        margin-right: 15px;
      }
    }
    // .content {
    //   height: 60px;
    //   display: flex;

    //   margin: 0 auto;
    //   font-size: 16px;
    //   align-items: center;
    //   justify-content: center;
    //   span {
    //     margin-left: 20px;
    //     a {
    //       color: #fff;
    //     }
    //   }
    // }
  }
}
// 手机端css
.mobile-content {
  .footer {
    // 移动端使用常规块级布局，避免 table 布局导致的宽度异常
    display: block;
    width: 100%;
    .footer-wrap {
      width: 100%;
      max-width: 345px;
      padding: 18px 0 32px;
      display: flex;
      flex-direction: column;
      // 移动端底部模块整体居中展示
      align-items: center;
      box-sizing: border-box;
      .logo-image {
        width: 100%;
        // 与二维码区域保持同一内容宽度，确保左边界对齐
        max-width: 312px;
        display: flex;
        flex-direction: column;
        // 品牌图与联系信息在移动端统一左对齐
        align-items: flex-start;
        .icon-image {
          width: 150px;
          height: 32px;
        }
        .contact-info {
          margin-top: 15px;
          // 联系信息在移动端按阅读习惯左对齐
          text-align: left;
          .company-name {
            font-size: 14px;
            color: #fff;
            font-weight: bold;
            margin-bottom: 10px;
            letter-spacing: 1px;
          }
          .contact-item {
            font-size: 13px;
            color: rgba(255, 255, 255, 0.8);
            line-height: 20px;
            letter-spacing: 1px;
            // 长文本在窄屏强制换行，避免向右溢出
            word-break: break-all;
          }
        }
      }
      .qrcode-wrap {
        width: 100%;
        max-width: 312px;
        margin-top: 24px;
        justify-content: center;
        gap: 12px;
        flex-wrap: wrap;
        box-sizing: border-box;
        .qrcode-item {
          width: calc((100% - 24px) / 3);
          max-width: 96px;
          min-width: 88px;
          .qrcode-img {
            width: 100%;
            height: auto;
            max-width: 96px;
          }
          .qrcode-text {
            font-size: 13px;
            margin-top: 8px;
          }
        }
      }
    }
    .copyright-wrap {
      padding: 20px 0 20px;
      .wrap-title {
        font-size: 14px;
        margin-left: 0;
        height: auto;
        line-height: 1.6;
        padding: 0 12px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        .copyright-text {
          margin-right: 10px;
        }
        .record-separator {
          margin-right: 10px;
          color: rgba(255, 255, 255, 0.5);
        }
        .image {
          width: 15px;
          height: 15px;
          margin-right: 5px;
        }
        .record-wrap {
          display: inline-flex;
          align-items: center;
          white-space: nowrap;
          flex: 0 0 100%;
          justify-content: center;
        }
        .license-wrap {
          display: inline-flex;
          align-items: center;
          white-space: nowrap;
          flex: 0 0 100%;
          justify-content: center;
          margin-top: 6px;
        }
        .license-icon {
          width: 15px;
          height: 15px;
          margin-left: 10px;
          margin-right: 3px;
        }
        .license-link {
          color: #fff;
          text-decoration: none;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
